import CallLogPagingResultModelBase from '../_generated/modelBases/call-log-paging-result-model-base';

export default class CallLogPagingResultModel extends CallLogPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
